import React, { ForwardRefRenderFunction, forwardRef } from 'react';
import { Button, ButtonProps } from '@chakra-ui/react';

interface Props extends ButtonProps {
    /** Primary buttons use a darker background with light text, while secondary buttons use the inverse */
    variant?: 'primary' | 'outline primary' | 'secondary' | 'destructive';
}

const buttonColors = {
    primary: {
        color: 'white',
        backgroundColor: 'primary.400',
        borderColor: 'primary.400',
        hoverBackgroundColor: 'primary.500'
    },
    'outline primary': {
        color: 'primary.400',
        backgroundColor: 'transparent',
        borderColor: 'primary.400',
        borderWidth: '1px',
        hoverBackgroundColor: 'var(--chakra-colors-gray-200)'
    },
    secondary: {
        color: 'primary.400',
        backgroundColor: 'transparent',
        borderColor: 'transparent',
        hoverBackgroundColor: 'var(--chakra-colors-gray-200)'
    },
    destructive: {
        color: 'white',
        backgroundColor: 'red.500',
        borderColor: 'red.500',
        hoverBackgroundColor: 'red.500'
    }
};

const ModernButton: ForwardRefRenderFunction<HTMLButtonElement, Props> = (
    { variant = 'primary', children, ...rest },
    ref
) => {
    const { color, backgroundColor, borderColor, hoverBackgroundColor } = buttonColors[variant];

    return (
        <Button
            ref={ref}
            type="button"
            color={color}
            cursor="pointer"
            backgroundColor={backgroundColor}
            border={`1px solid ${borderColor}`}
            height="36px"
            fontFamily="'azo-sans-web', 'Helvetica', 'Arial', sans-serif"
            fontSize="12px"
            lineHeight="18px"
            borderRadius="8px"
            _hover={{
                backgroundColor: hoverBackgroundColor,
                color: color,
                '&:disabled': { backgroundColor }
            }}
            _focus={{
                boxShadow: 'none'
            }}
            _focusVisible={{
                boxShadow: 'outline',
                '&:disabled': { backgroundColor }
            }}
            _active={{
                '&:disabled': { backgroundColor }
            }}
            {...rest}
        >
            {children}
        </Button>
    );
};
/**
 * @deprecated This component is deprecated. Please use Chakra UI's Button component instead.
 */

export default forwardRef(ModernButton);
